import React from "react";

const AlertBlog = ({ texto }) => {
    return (
        <div style={{ width: "100%", display: "flex", justifyContent: "center", padding: "20px 20px", fontFamily: "'Inter', sans-serif", }} >
            <div style={{ maxWidth: "800px", width: "100%", background: "#F9F0EF", border: "1px solid #E8B5AE", borderLeft: "4px solid #C0392B", borderRadius: "10px", padding: "22px 28px", }} >
                <span style={{ display: "block", color: "#C0392B", fontSize: "14px", fontWeight: "700", letterSpacing: "2px", textTransform: "uppercase", marginBottom: "14px", }} >
                    Atenção
                </span>
                <p style={{ margin: 0, color: "#5A1E16", fontSize: "15px", lineHeight: 1.3, fontWeight: 400, textAlign: "justify", }} >
                    {texto}
                </p>
            </div>
        </div>
    );
};

export default AlertBlog;